var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"report","fluid":"","tag":"section"}},[_c('FilterForm',{attrs:{"filter-form":_vm.filterForm}}),_c('SaleLeaderTable',{attrs:{"leader":_vm.leader,"report":_vm.report}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }